import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ModalComponent } from "../../modules/modal/modal.component";
import { ModalHeaderComponent } from "../../modules/modal/modal.header.component";
import { S25ExpressSchedulingComponent } from "./s25.express.scheduling.component";
import type { ExpressSchedulingInitContext } from "./s25.express.scheduling.types";

type ExpressSchedulingModalData = Pick<ExpressSchedulingInitContext, "itemId" | "startDt" | "endDt">;

@Component({
    selector: "s25-ng-express-scheduling-modal",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ModalHeaderComponent, S25ExpressSchedulingComponent],
    template: `
        <s25-modal-header [data]="params()" />
        <div class="modal-body">
            <s25-ng-express-scheduling [initContext]="params()" />
        </div>
    `,
})
export class ExpressSchedulingModal extends ModalComponent<ExpressSchedulingModalData> {
    static readonly size = "md";
    static readonly title = "Express Scheduling";
    static readonly asDialog = true;
}
